<template>
  <div class="main">
    <!-- <weui-toast :show="showToast"
                :loading-type="true">
      <p>加载中</p>
    </weui-toast> -->
    <!-- <div class="client"
         v-if="!showToast"> -->
    <div class="client">
      <div class="client_list" v-if="list && list.length > 0">
        <div class="client_item" v-for="( v , index ) in list" :key="index"  
         @click="jump(`/clientDetail.html?familyId=${v.id}`)">
          <div class="title">
            <img v-if="v.sex == '男'"
              class="avatar"
              src="../../assets/images/avatar-boy.png"
              alt="">
            <img v-else-if="v.sex == '女'"
              class="avatar"
              src="../../assets/images/avatar-girl.png"
              alt="">
            <img v-else
              class="avatar"
              src="../../assets/images/avatar_default.png"
              alt="">
            <span class="name">
              {{ v.name ? v.name : '--' }}
            </span>
            <span class="tip" v-if="v.isDefault">默认</span>
          </div>
          <div class="num">
            <i class="dot"></i>证件号 {{ v.cardId ? v.cardId : '--' }}</div>
          <div class="num mb-0">
            <i class="dot"></i>
            手机号 {{ v.phone ? v.phone : '--' }}</div>
          <span class="right_btn"></span>
        </div>
      </div>
      <div class="client_list" v-else>
        <div class="nodata">
          <img src="../../assets/images/coupon_nodata_img.png"
               alt="">
          <div class="ntext">暂无就诊人<br />请添加就诊人</div>
        </div>
      </div>
      <div class="fixbtn">
        <div class="add_btn" @click="jump(`/clientDetail.html`)">添加就诊人</div>
      </div>
    </div>
  </div>
</template>

<script>
import Lib from "../../assets/Lib.js";
import toast from "../../components/toast.vue";

export default {
  name: "index",
  data() {
    return {
      // showToast: true,
      list: [],
      openid: null,
      token: "",
    };
  },
  components: {
    "weui-toast": toast,
  },
  methods: {
    init() {
      // this.showToast = true;
      Lib.M.ajax({
        type: "get",
        url: Lib.C.api.getMemberList,
        header: {
          token: this.token || "",
        },
        success: (res) => {
          if (res.code == 200) {
            this.list = res.data || [];
          }
        },
        complete: () => {
          // this.showToast = false;
        },
      });
    },
    jump(url) {
      location.href = Lib.M.joinUrlPath(url);
    },
    deletes() {
      Lib.M.wsCache.clear();
      Lib.M.MsgBox.alert("缓存删除成功");
    },
  },
  created() {},
  mounted() {
    if (Lib.device.isWeixin) {
      this.openid = Lib.M.wsCache.get("openid");
      this.token = Lib.M.wsCache.get("token");
      console.log("首页的openid", this.openid);
      console.log("首页的token", this.token);
      if (!this.openid || !this.token) {
        Lib.M.verifyphonesns(() => {
          this.init();
        });
      } else {
        this.init();
      }
    }
  },
};
</script>

<style lang="less">
.main {
  .client {
    padding-bottom: 1.28rem;
    .client_list {
      padding: 0 0.3rem;
      padding-bottom: 1.28rem;
      .client_item {
        width: 6.9rem;
        background-color: #fff;
        box-shadow: 0 0 0.3rem 0 rgba(0, 0, 0, 0.08);
        border-radius: 0.12rem;
        padding: 0.3rem;
        margin-top: 0.4rem;
        position: relative;
        .title {
          margin-bottom: 0.34rem;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          .avatar {
            width: 0.7rem;
            height: 0.7rem;
            margin: 0;
            border-radius: 50%;
            margin-right: 0.2rem;
          }
          .name {
            max-width: 4.2rem;
            color: #303237;
            font-size: 0.32rem;
            font-weight: bolder;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 0.2rem;
          }
          .tip {
            display: inline-block;
            padding: 0.02rem 0.14rem;
            background: #3ce2aa;
            color: #fff;
            font-size: 0.24rem;
            text-align: center;
            border-radius: 0.1rem;
          }
        }
        .num {
          font-size: 0.26rem;
          font-weight: 400;
          color: #666b76;
          line-height: 0.26rem;
          margin-bottom: 0.24rem;
          position: relative;
          padding-left: 0.24rem;
          .dot {
            display: block;
            height: 0.08rem;
            width: 0.08rem;
            background-color: #d7d9df;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -0.04rem;
          }
        }
        .mb-0 {
          margin-bottom: 0.1rem;
        }
        .right_btn {
          display: block;
          height: 0.5rem;
          width: 0.5rem;
          background: url(../../assets/images/change_list_btn.png);
          background-size: 100% 100%;
          position: absolute;
          right: 0.3rem;
          top: 1rem;
        }
      }
      .nodata {
        text-align: center;
        padding-top: 2rem;
        padding-bottom: 2rem;
        img {
          display: block;
          margin: 0 auto;
          height: 1.8rem;
          width: 2.6rem;
        }
        .ntext {
          display: block;
          color: #9ca1af;
          font-size: 0.28rem;
          margin-top: 0.5rem;
        }
      }
    }
    .fixbtn {
      height: 2rem;
      width: 100%;
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 9;
      background-color: #fff;
      box-shadow: 0px -0.04rem 0.08rem 0px rgba(48, 50, 55, 0.04);
      color: #303237;
      overflow: hidden;
      text-align: center;
      padding-top: 0.5rem;
      .add_btn {
        width: 6rem;
        height: 0.96rem;
        line-height: 0.96rem;
        text-align: center;
        color: #fff;
        background-color: #00a0e4;
        box-shadow: 0px 12px 12px 0px rgba(0, 0, 0, 0.06);
        border-radius: 0.2rem;
        font-size: 0.32rem;
        margin-bottom: 1rem;
      }
    }
  }
}
</style>
